import React from 'react';
import CrossingOutWardReport from '../CrossingOutwardReport';
import CrossingOutWardReportForBBAC from '../CrossingOutWardReportForBBAC';

export default function CrossingOutwardReportPage({ sessionObject }) {
  const client = process.env.REACT_APP_CLIENT;

  if (client === "bbac") {
    return (
      <div className="page-bilty">
        <CrossingOutWardReportForBBAC sessionObject={sessionObject} />
      </div>
    );
  }

  return (
    <div className="page-bilty">
      <CrossingOutWardReport sessionObject={sessionObject} />
    </div>
  );
}